export default "__VITE_ASSET__axfMTj4E__"